import { ActionProps } from '../02-atoms/Action';
import { Actions } from './Actions';

export interface DividerProps {
  /** Optional title */
  title?: string;
  /** Optional actions */
  actions?: ActionProps[];
  /** Small */
  small?: boolean;
  /** Additional class */
  className?: string;
}

/** A divider */
export const Divider = ({ title, actions, small, className }: DividerProps) => {
  return (
    <div
      className={['divider', small && 'divider--small', className].join(' ')}
    >
      {title && <p className="divider__title">{title}</p>}
      {actions && <Actions className="divider__actions" items={actions} />}
      <hr className="divider__line" />
    </div>
  );
};
